import React, { useState } from "react";
import CommonButton from "../../../CommonComponents/CommonButton";
import TextField from "@mui/material/TextField";
import { Grid, Typography, Card, Box } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import style from "./Reject.module.css";

const theme = createTheme({
  palette: {
    textField_bordercolor: {
      main: "#CCC",
    },
  },
});

const Reject = ({ onSubmit = () => {}, setOpenActionModal = () => {} }) => {
  const [remarks, setRemarks] = useState("");
  const [isTextFieldEnabled, setIsTextFieldEnabled] = useState(false);

  const handleNoClick = () => {
    setIsTextFieldEnabled(false);
    setOpenActionModal(false);
    // onSubmit(false, remarks);
  };

  const handleYesClick = () => {
    setIsTextFieldEnabled(true);
  };

  const handleRemarkChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleSubmit = (e) => {
    if (isTextFieldEnabled) {
      onSubmit(true, remarks);
    } else {
      onSubmit(false, remarks);
    }
  };

  return (
    <div id={style["reject_box"]}>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{
            paddingBottom: "10px",
            paddingTop: "10px",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.6rem",
              fontWeight: "500",
              color: "#505050",
              textAlign: "center",
            }}
          >
            Are you sure you want to reject?
          </Typography>
        </Grid>
      </Grid>
      <div className={style["common_button"]}>
        <div className={style["no_button"]}>
          <CommonButton
            label="No"
            backgroundColor
            filledButton
            onClick={handleNoClick}
          />
        </div>
        <div className={style["yes_button"]}>
          <CommonButton label="Yes" backgroundColor onClick={handleYesClick} />
        </div>
      </div>

      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { m: 1, width: "40ch" },
          "& .MuiInputBase-root": {
            padding: "10px",
          },
        }}
        noValidate
        autoComplete="off"
      >
        <div className={style["heading"]}>
          <Typography sx={{ color: "#7C7C7C", fontSize: "1.6rem" }}>
            Remark
          </Typography>
        </div>
        <div className={style["main_remark"]}>
          <ThemeProvider theme={theme}>
            <TextField
              inputProps={{
                style: { fontSize: "1.4rem", lineHeight: "1.8rem" },
              }}
              sx={{ width: "100%" }}
              color="textField_bordercolor"
              multiline
              margin="none"
              placeholder="Enter Remarks"
              rows={3}
              disabled={!isTextFieldEnabled}
              value={remarks}
              onChange={handleRemarkChange}
            />
          </ThemeProvider>
        </div>
      </Box>
      {remarks.length > 0 ? (
        <div className={style["submit_button"]}>
          <CommonButton
            onClick={handleSubmit}
            label="Submit"
            backgroundColor
            filledButton
          />
        </div>
      ) : null}
    </div>
  );
};

export default Reject;
